/*
 * Copyright (c) 2026. Orion Analytics
 */

import React, { useCallback, useEffect, useMemo, useState } from "react";
import Plot from "react-plotly.js";
import { fetchMarketIndices } from "../../api";

export default function HomeIndexChart() {

    const [indices, setIndices] = useState([]);
    const [selected, setSelected] = useState("NIFTY 50");

    const allowedSymbols = [
        "NIFTY 50",
        "NIFTY BANK",
        "INDIA VIX",
        "NIFTY IT",
        "NIFTY AUTO"
    ];


    const fetchData = useCallback (async () => {

            fetchMarketIndices(true).then((data) => {

            const parsed = JSON.parse(data.hist_df);

            const filtered = parsed.filter(
                item =>
                    item &&
                    allowedSymbols.includes(item.symbol)
            );

            setIndices(filtered);

        });
      }, []);

    // Auto-refresh every 30 seconds
    useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 30000);
    return () => clearInterval(intervalId);
  }, [fetchData]);



    const chartData = useMemo(() => {

        const data = indices.filter(
            d => d.symbol === selected
        );

        return {
            x: data.map(d => d.date),
            y: data.map(d => d.close)
        };

    }, [indices, selected]);

    const latest = useMemo(() => {

        const result = {};

        allowedSymbols.forEach(symbol => {

            const rows = indices.filter(
                d => d.symbol === symbol
            );

            if (rows.length > 0) {

                result[symbol] =
                    rows[rows.length - 1].close;

            }

        });

        return result;

    }, [indices]);

    return (

        <div className="
            bg-slate-950
            rounded-3xl
            border
            border-slate-800
            p-6
        ">

            {/* HEADER */}

            <div className="
                    flex
                    flex-row
                    flex-wrap
                    gap-3
                    mb-6
            ">

                <StatCard
                    title="NIFTY 50"
                    value={latest["NIFTY 50"]}
                />

                <StatCard
                    title="BANK NIFTY"
                    value={latest["NIFTY BANK"]}
                />

                <StatCard
                    title="VIX"
                    value={latest["INDIA VIX"]}
                />

                <StatCard
                    title="AUTO"
                    value={latest["NIFTY AUTO"]}
                />

            </div>

            {/* TABS */}

            <div className="w-full overflow-x-auto">

                <div
                    className="
                        flex
                        flex-nowrap
                        gap-3
                        mb-6
                        min-w-max
                    "
                >
                    {allowedSymbols.map(symbol => (

                        <button
                            key={symbol}
                            onClick={() => setSelected(symbol)}
                            className={`
                                px-4
                                py-2
                                rounded-xl
                                whitespace-nowrap
                                ${
                                    selected === symbol
                                        ? "bg-emerald-500 text-white"
                                        : "bg-slate-900 text-slate-300"
                                }
                            `}
                        >
                            {symbol}
                        </button>

                    ))}
                </div>
            </div>
            {/* CHART */}

            <Plot
                data={[
                    {
                        x: chartData.x,
                        y: chartData.y,
                        type: "scatter",
                        mode: "lines",
                        line: {
                            width: 3
                        }
                    }
                ]}
                layout={{
                    height: 320,
                    margin: {
                        l: 50,
                        r: 20,
                        t: 10,
                        b: 40
                    },

                    paper_bgcolor: "#020617",
                    plot_bgcolor: "#020617",

                    font: {
                        color: "#cbd5e1"
                    },

                    xaxis: {
                        type: "date",
                        showgrid: false,
                        rangeslider: {
                            visible: false
                        }
                    },

                    yaxis: {
                        showgrid: true,
                        gridcolor: "#1e293b",
                        autorange: true,
                        fixedrange: true,
                        tickformat: ",d"
                    }
                }}
                config={{
                    displayModeBar: false,
                    responsive: true
                }}
                style={{
                    width: "100%"
                }}
            />

        </div>

    );

}

function StatCard({ title, value }) {

    return (

        <div className="
            bg-slate-900
            rounded-2xl
            px-5
            py-4
            min-w-[140px]
            border
            border-slate-800
        ">

            <div className="
                text-xs
                uppercase
                text-slate-500
            ">
                {title}
            </div>

            <div className="
                text-xl
                font-bold
                text-white
            ">
                {value?.toLocaleString()}
            </div>

        </div>

    );

}
